import { PUBLIC_API_URL } from '../../../app-config/constants';
import { post } from '../request';

const ENTRY = `${PUBLIC_API_URL}/support-requests`;

export function sendFeedback(payload) {
    return post(`${ENTRY}`, { postData: payload });
}
